import { Dispatch, RefObject, SetStateAction, useEffect, useRef, useState } from 'react';

type UseClickOutside = [
  boolean,
  Dispatch<SetStateAction<boolean>>,
  RefObject<HTMLDivElement>,
  RefObject<HTMLDivElement>,
];
type OnClickOustide = (e: MouseEvent) => void;

function useClickOutside(onClickOutside?: OnClickOustide, tableScrollRight = 0): UseClickOutside {
  const ref = useRef<HTMLDivElement>(null);
  const self = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(false);
  }, [tableScrollRight]);

  const isClickingOutside = e => {
    return (
      !(ref && ref.current && ref.current.contains(e.target)) &&
      !(self && self.current && self.current.contains(e.target))
    );
  };

  const handleClick = (e: MouseEvent) => {
    if (isClickingOutside(e)) {
      setOpen(false);
      if (onClickOutside) {
        onClickOutside(e);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [open, setOpen, ref, self];
}

export default useClickOutside;
